import { apiURL, callAPI } from 'api/main';

export default async (): Promise<Array<number> | null> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/api/survey/get`,
      method: 'GET',
      needToken: true,
    });

    const { data } = res.request;

    if (data) {
      return (data || [])?.map((survey: any) => survey?.Id);
    }

    return null;
  } catch (ex) {
    return null;
  }
};
